import {
  isBlockedAccountStatus,
  normalizeAccountStatus,
} from "@/lib/accountDeletion/status";

const PUBLIC_USER_ROLES = new Set(["admin", "business", "customer"]);

export function normalizePublicUserRole(value) {
  if (typeof value !== "string") return null;
  const role = value.trim().toLowerCase();
  return PUBLIC_USER_ROLES.has(role) ? role : null;
}

export function buildCurrentAccountContext({
  user = null,
  profile = null,
  businessRowExists = false,
  businessAccessContexts = [],
  roleOverride = null,
} = {}) {
  const role = normalizePublicUserRole(roleOverride) || normalizePublicUserRole(profile?.role);
  const accountStatus = normalizeAccountStatus(profile?.account_status);
  const isBlocked = isBlockedAccountStatus(accountStatus);
  const isAuthenticated = Boolean(user?.id);
  const isRoleResolved = isAuthenticated ? Boolean(role) : true;
  const isBusiness = role === "business";
  const isAdmin = role === "admin";
  const canPurchase = role === "customer" && !isBlocked;

  return {
    user: user ?? null,
    profile: profile ?? null,
    role,
    accountStatus,
    isBlocked,
    isAuthenticated,
    isRoleResolved,
    businessRowExists: Boolean(businessRowExists),
    hasBusinessAccess: Boolean(businessRowExists) || businessAccessContexts.length > 0,
    businessAccessContexts,
    isBusiness,
    isAdmin,
    canPurchase,
  };
}

export function logCurrentAccountContext({
  source = "unknown",
  host = null,
  context,
}) {
  if (!context?.isAuthenticated) return;

  console.info("[ACCOUNT_CONTEXT_DEBUG]", {
    source,
    hostPresent: Boolean(host),
    authUserPresent: Boolean(context.user?.id),
    authEmailPresent: Boolean(context.user?.email),
    usersRole: context.role || null,
    businessRowExists: context.businessRowExists === true,
    hasBusinessAccess: context.hasBusinessAccess === true,
    canPurchase: context.canPurchase === true,
    isBusiness: context.isBusiness === true,
  });
}
